import { memo, useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { checkExpandedRowsContainRow } from "../../../../selectors/home"
import { RootState } from "../../../../store"
import { Typography } from "@mui/material"
import { matchPath } from "react-router-dom"
import ROUTES from "../../../../assets/routes"
import { OptionChainViewKey } from "../../../../assets/constants"

const getExpandedRowClassName = (darkTheme: boolean): string => {
    const baseClasses = 'flex h-full items-center justify-between align-middle font-feature-num'
    const backgroundClass = darkTheme ? 'bg-row-dark' : 'bg-row'
    return `${baseClasses} ${backgroundClass}`
}

const getCollapsedRowClassName = (darkTheme: boolean): string => {
    const baseClasses = 'flex h-full items-center justify-between align-middle font-feature-num'
    const backgroundClass = darkTheme ? 'bg-row-open-dark' : 'bg-row-open'
    return `${baseClasses} ${backgroundClass}`
}

const RenderExpiryPcrIvx = ({ ivxExpiry, pcrExpiry, RecKey, optionTypeOnly = false }: { ivxExpiry: number, pcrExpiry: number, RecKey: string, optionTypeOnly?: boolean }) => {
    const rowExpanded = useSelector(checkExpandedRowsContainRow(RecKey, matchPath(ROUTES.simulator, window.location.pathname) ? OptionChainViewKey.HISTORICAL : OptionChainViewKey.LIVE))
    const darkTheme = useSelector((store: RootState) => store.commonStore.darkTheme)
    const ivx = ivxExpiry * 100 ? (ivxExpiry * 100)?.toFixed(2) : '-'
    const pcr = pcrExpiry ? pcrExpiry?.toFixed(2) : '-'
    const [fullWidth, setFullWidth] = useState("100%");
    const rowRef = useRef<HTMLDivElement>(null);
    const expandedRowClassName = getExpandedRowClassName(darkTheme)
    const collapsedRowClassName = getCollapsedRowClassName(darkTheme)
    
    if (rowExpanded || optionTypeOnly) {
        return (
            <div
                ref={rowRef}
                className={expandedRowClassName}
                style={{
                    display: 'flex',
                    width: fullWidth,
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    minWidth: "100%",
                    position: 'relative'
                }}>
                <div className="puts-heading-sticky" style={{
                    position: 'sticky',
                    left: 0,
                    zIndex: 5,
                    paddingLeft: '8px',
                    paddingRight: '8px'
                }}>Puts</div>
                {
                    optionTypeOnly ? <div></div> :
                        <div className="flex items-center pcr-ivx-sticky" style={{
                            position: 'sticky',
                            right: 0,
                            zIndex: 5,
                            paddingRight: '8px'
                        }}>
                            <div className="flex" style={{ width: '80px', textAlign: 'left' }}><Typography
                                sx={{ color: (theme) => theme.palette.text.secondary }} fontSize={14}
                                style={{ marginRight: '5px' }}>PCR </Typography>{` ${pcr}`}</div>
                            <div className="flex" style={{ width: '80px', textAlign: 'left' }}><Typography
                                sx={{ color: (theme) => theme.palette.text.secondary }} fontSize={14}
                                style={{ marginRight: '5px' }}>IVx </Typography>{` ${ivx}`}</div>
                        </div>
                }
            </div>
        )
    }
    return (
        <div
            ref={rowRef}
            className={collapsedRowClassName}
            style={{
                display: 'flex',
                width: fullWidth,
                justifyContent: 'space-between',
                alignItems: 'center',
                minWidth: "100%",
                position: 'relative'
            }}>
            <div className="puts-heading-sticky" style={{
                flex: "1"
            }}></div>
            <div className="flex items-center pcr-ivx-sticky" style={{
                position: 'sticky',
                right: 0,
                zIndex: 10,
                paddingRight: '8px'
            }}>
                <div className="flex" style={{ width: '80px', textAlign: 'left' }}><Typography
                    sx={{ color: (theme) => theme.palette.text.secondary }} fontSize={14}
                    style={{ marginRight: '5px' }}>PCR </Typography>{` ${pcr}`}</div>
                <div className="flex" style={{ width: '80px', textAlign: 'left' }}><Typography
                    sx={{ color: (theme) => theme.palette.text.secondary }} fontSize={14}
                    style={{ marginRight: '5px' }}>IVx </Typography>{` ${ivx}`}</div>
            </div>
        </div>
    )
}

export default memo(RenderExpiryPcrIvx)